import React, { useState, useEffect } from 'react';
import { i18n } from 'utils/i18n';
import { sanitize } from 'utils/validation';
import useActions from 'hooks/useActions';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import { useSelector } from 'react-redux';
import { getAfterHoursPolicy } from 'actions/reservation/getAfterHoursPolicy';
import { formattedPoliciesSelector } from 'selectors/policiesSelectors';
import {
  getIsAfterHoursPickup,
  getIsAfterHoursReturn,
  getReservationPickupLocation,
  getReservationReturnLocation,
} from 'selectors/reservationSelectors';

const RentalDetailsAfterHoursModal = () => {
  const [altAfterHoursPolicyContent, setAltAfterHoursPolicyContent] = useState(null);

  const getAfterHoursPolicyAction = useActions(getAfterHoursPolicy);
  const policies = useSelector((state) => formattedPoliciesSelector(state));
  const afterHoursReturn = useSelector((state) => getIsAfterHoursPickup(state));
  const afterHoursPickup = useSelector((state) => getIsAfterHoursReturn(state));
  const pickupLocation = useSelector((state) => getReservationPickupLocation(state));
  const returnLocation = useSelector((state) => getReservationReturnLocation(state));

  const setAfterHoursPolicy = () => {
    getAfterHoursPolicyAction({
      policies,
      afterHoursReturn,
      afterHoursPickup,
      pickupLocation,
      returnLocation,
    }).then((content) => {
      if (content) {
        setAltAfterHoursPolicyContent(content);
      }
    });
  };

  useEffect(() => {
    if (policies) {
      setAfterHoursPolicy();
    }
  }, []);

  return (
    <Modal
      modalKey={MODAL.RENTAL_DETAILS_AFTER_HOURS_MODAL}
      header={i18n('rental_details_after_hours_modal_header')}
      theme={MODAL_THEMES.WHITE}
    >
      {() => (
        <div
          id={`${MODAL.RENTAL_DETAILS_AFTER_HOURS_MODAL}_desc`}
          className='modal-themed__section modal-themed__gbo-content'
          dangerouslySetInnerHTML={sanitize(altAfterHoursPolicyContent)}
        />
      )}
    </Modal>
  );
};

export default RentalDetailsAfterHoursModal;
